import React from 'react';
import SectionHeader from './SectionHeader';
import CurrencyInput from './CurrencyInput';
import NotesInput from './NotesInput';
import AutoCheckbox from './AutoCheckbox';

/**
 * Section 13 — Savings
 */
export default function StepSavings({ data = {}, onChange }) {
  function set(field, value) {
    onChange({ ...data, [field]: value });
  }

  const rows = [
    {
      key: 'retirement_savings',
      autoKey: 'retirement_savings_auto',
      label: 'Retirement Savings (401(k), IRA, etc.)',
      hint: '2026 max: 401(k) $24,500 (catch-up 50+: +$8,000; age 60-63: +$11,250) · IRA $7,500 (catch-up 50+: +$1,100)',
    },
    {
      key: 'hsa_fsa',
      autoKey: 'hsa_fsa_auto',
      label: 'HSA and/or FSA Savings',
      hint: '2026 max: HSA $4,400 self / $8,750 family (catch-up 55+: +$1,000) · FSA $3,300',
    },
    { key: 'education_savings_529', label: 'Education Savings (529s, College Accounts, etc.)' },
    { key: 'brokerage_taxable', label: 'Brokerage / Taxable Savings' },
    { key: 'other_savings', label: 'Other Savings' },
  ];

  const total = rows.reduce(
    (sum, r) => sum + (Number(data[r.key]) || 0),
    0
  );

  return (
    <div>
      <SectionHeader
        number={13}
        title="Savings"
        tip="List all savings contributions, check the AUTO box to have our team review your payslip for figures."
      />

      <div className="alert alert-warning d-flex align-items-start gap-3 mb-4">
        <span style={{ fontSize: '2rem', lineHeight: 1 }}>💡</span>
        <span>
          <strong>Enter the amount you contribute each year — not your current account balance.</strong>
          {' '}For example, if you put $500/month into an IRA, enter $6,000.
        </span>
      </div>

      {rows.map(({ key, autoKey, label, hint }) => (
        <div key={key} className="mb-3 pb-2 border-bottom">
          <CurrencyInput
            id={key}
            label={label}
            hint={hint}
            value={data[key] ?? null}
            onChange={(val) => set(key, val)}
          />
          {autoKey && (
            <AutoCheckbox
              id={`${autoKey}_check`}
              checked={!!data[autoKey]}
              onChange={(val) => set(autoKey, val)}
            />
          )}
        </div>
      ))}

      {total > 0 && (
        <div className="cashflow-total-box mt-3">
          <span className="fw-semibold">12: Total Savings</span>
          <span className="cashflow-total-amount">
            ${total.toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 })}
          </span>
        </div>
      )}

      <NotesInput value={data.notes} onChange={(val) => set('notes', val)} />
    </div>
  );
}
